"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LabelledCheckboxes;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _useCheckbox3 = _interopRequireDefault(require("./useCheckbox"));

function LabelledCheckboxes(props) {
  var options = props.options,
      name = props.name,
      label = props.label;

  var _useCheckbox = (0, _useCheckbox3["default"])(name),
      _useCheckbox2 = (0, _slicedToArray2["default"])(_useCheckbox, 2),
      value = _useCheckbox2[0],
      onChange = _useCheckbox2[1];

  return _react["default"].createElement(_react["default"].Fragment, null, label && _react["default"].createElement("label", null, label), options.map(function (option) {
    var label = option.label,
        other = (0, _objectWithoutProperties2["default"])(option, ["label"]);
    return _react["default"].createElement(_reactstrap.CustomInput, (0, _extends2["default"])({
      key: label,
      type: "checkbox",
      id: label,
      label: label,
      onChange: onChange,
      checked: value && value.includes(option.value)
    }, other));
  }));
}